import React from 'react';
import SidebarUnitDesktop from "components/sidebar/components/SidebarUnitDesktop";
import { StarIcon } from "assets/icons";

const JobPostTemplateLink = () => {
    return (
        <SidebarUnitDesktop
            routeName={"Fiches de postes"}
            routeSidebar={"/jobPostTemplates"}
            icon={StarIcon}
            text={"Fiches de postes"}
        />
    );
};

export default JobPostTemplateLink;
